import EditarCotizacion from './EditarCotizacion'

export default EditarCotizacion
